import { appStateMutations } from './mutationFactory';
import { AppState, MutationAction } from './types';

export const initialState = {
  modal: null,
  modalData: undefined,
  // NEW INITIAL AUTH STATE
  isAuthenticated: false,
  accessToken: null,
  user: null,
  mapbox: { sessionToken: null },
  products: { data: null, loading: false, ready: false, error: null },
  reviews: { data: {} },
};

export const reducer = (state: AppState, action: MutationAction): AppState => {
  const mutation =
    appStateMutations[action.type as keyof typeof appStateMutations];
  if (!mutation) {
    console.error(`No mutation found for action: ${action.type}`);
    return state;
  }
  // @ts-ignore - mapping the specific union type to the factory function
  return mutation(state, action);
};
